export enum PopupLevel {
  Info = 1,
  Warning = 2,
  Error = 3
}

export enum HeimvorteilProduktart {
  Eigenheim = 1,
  Haushalt = 2,
  Buendel = 3
}

export enum HeimvorteilGebaeudeart {
  Wohnung = 1,
  Haus = 2
}

export enum ProduktArt {
  Eigenheim = 1,
  Haushalt = 2,
  Buendel = 3,
  Rechtschutz = 4,
  Kfz = 5,
  Motorrad = 6
}

export enum ErrorMessageType {
  General = 1,
  OffertLoad = 2,
  OffertCreate = 3,
  AntragCreate = 4,
  CalculateRate = 5,
  Eurotax = 6,
  EurotaxService = 7
}

export enum UploadDokumentArt {
  Antrag = 1,
  BmNachweis = 2,
  Kaskobesichtigung = 3,
  Sonderausstattung = 4,
  Sonstige = 5
}

export enum UserType {
  Mitarbeiter = 1,
  Vermittler = 2,
  Direktkunde = 3
}
